module.exports = __webpack_public_path__ + "img/ae.e39cd334.svg";